import * as http from 'axios'
const defaultEndpoint = require('@/endpoint')

export const getRedeDrAchei = (id) => http.get(`/redes/${id}?populate=tipo especialidade tipoUnidade especialidades`)
export const getRede = (id) => http.get(`${defaultEndpoint.urlGrupoSin}/api/rede/${id}?populate=tipo especialidade tipoUnidade especialidades`)
// export const getRede = (id) => http.get(`/redes/${id}`)
export const savePrecadastro = (payload) => http.post('/redes/precadastro', payload)
export const ativarPrecadastro = (payload) => http.post('/redes/validarPrecadastro', payload)
export const update = (id, payload) => http.put(`/redes/${id}`, payload)
export const listEspecialidadeRede = (id) => http.get(`/redes/${id}/especialidades`)
export const getAvaliacoes = (id) => http.get(`/depoimentos?rede=${id}&populate=cliente&exibeSite=true`)
export const getConsulta = (idConsulta) => http.get(`/redeConsultas/${idConsulta}?populate=especialidade`)
export const listAll = (query) => http.get('/redes?sort=nomeRede', {params: query})
export const getExames = (idRede, exames) => http.get(`/redeExames?rede=${idRede}&_id__in=${exames}`)
export const getExamesByQuery = (idRede, name) => http.get(`/redeExames?rede=${idRede}&&nomeExame__regex=/.*${name}.*/i`)
export const getRedesPorCodigoRede = (codigoRede) => http.get(`/redes?codigoRede=${codigoRede}`)
export const getRedesPorTipoENumeracaoInicialCartao = (tipoOrcamento, numeracaoInicialCartao) => http.get(`/redes?tipoRede__in=${tipoOrcamento}&numeracaoInicialCartao=${numeracaoInicialCartao}`)



// WEBPACK FOOTER //
// ./src/store/rede/services.js